import React, { useState } from 'react';

import { Typography, Box } from '@mui/material';
import { isMobile } from 'react-device-detect';

import { Tab } from '../../@types/State';
import { useIntelState } from '../../context/IntelState';
import useBuildingBookNames from '../../hooks/useBuildingBookNames';
import { useRecentIntel } from '../../hooks/useRecentIntel';
import IntelGridTabs from '../Intel/components/IntelGridTabs';
import ArmyGrid from '../Intel/gridViews/ArmyGrid';
import MainGrid from '../Intel/gridViews/MainGrid';

const Intel = () => {
  const [currentTab, setCurrentTab] = useState<Tab>('overview');
  const [bookNames, buildNames] = useBuildingBookNames();
  const { intelState } = useIntelState();
  useRecentIntel();

  const renderIntelGrid = () => {
    if (currentTab === 'armies') {
      return (
        <ArmyGrid dataSet={intelState.recentData} isViewingEnemy={false} />
      );
    }
    return (
      <MainGrid
        dataSet={intelState.recentData}
        plan={undefined}
        currentTab={currentTab}
        isViewingEnemy={true}
        hideTotals={true}
        isViewingRecent={true}
        zoom={100}
      />
    );
  };

  return (
    <div className='Home'>
      <Box
        className='Home'
        sx={{
          mt: isMobile ? 0 : 2,
        }}
      >
        <Box
          sx={{
            height: '50px',
            display: { xs: 'flex' },
            alignItems: 'center',
            marginX: 1,
          }}
        >
          <Typography variant='h2' component='span'>
            Recent Intel
          </Typography>
        </Box>

        <IntelGridTabs
          currentTab={currentTab}
          handleChangeTab={(e: any, newValue: any) => setCurrentTab(newValue)}
          hasBookNames={!!bookNames}
          hasBuildingNames={!!buildNames}
          isRecentView
        />

        <Box
          style={{ minHeight: 200 }}
          sx={{
            mx: 1,
            mb: 2,
          }}
        >
          <div style={{ width: '100%' }}>{renderIntelGrid()}</div>
        </Box>
      </Box>
    </div>
  );
};

export default Intel;
